import { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { logout } from '../../../../../../store/auth/actions';
import * as selectorsAuth from '../../../../../../store/auth/reducer';

const getBase64 = (image) => (
  image && image.includes('data:image') ? image : `data:image/png;base64,${image}`
);

const getUserInitials = (name) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) {
    const word = parts[0];
    return word.length === 1
      ? word.toUpperCase()
      : `${word.charAt(0)}${word.charAt(word.length - 1)}`.toUpperCase();
  }
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};

const AccountMenu = ({ authData, history, logout: logoutAction }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const userName = authData?.nome || 'Usuário';
  const userEmail = authData?.email;
  const avatarSrc = authData?.avatar ? getBase64(authData.avatar) : undefined;
  const userInitials = getUserInitials(userName);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logoutAction(history);
  };

  return (
    <>
      <Tooltip title={userName}>
        <IconButton
          aria-label="conta do usuário"
          color="inherit"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          sx={{
            p: 0.5,
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          }}
        >
          <Avatar
            alt={userName}
            src={avatarSrc}
            sx={{
              width: 36,
              height: 36,
              fontSize: '0.875rem',
              fontWeight: 600,
              bgcolor: 'action.selected',
              color: 'text.primary',
            }}
          >
            {userInitials}
          </Avatar>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 220,
            borderRadius: 2,
            p: 0.5,
          },
        }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {userName}
          </Typography>
          {userEmail && (
            <Typography variant="caption" color="text.secondary" noWrap display="block">
              {userEmail}
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 0.5 }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ borderRadius: 1.5, py: 1 }}
        >
          <ListItemIcon>
            <LogoutOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sair" />
        </MenuItem>
      </Menu>
    </>
  );
};

AccountMenu.propTypes = {
  authData: PropTypes.object,
  history: PropTypes.object,
  logout: PropTypes.func.isRequired,
};

AccountMenu.defaultProps = {
  authData: {},
};

const mapStateToProps = (state) => ({
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  logout,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountMenu));
